import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import './Search.styles.less';

const Search = ({ searchState, searchToken, handleOnChange, handleOnClose, noGuests, onAddGuestGroup }) => (
  <React.Fragment>
    <div className="sc__search">
      <div className={cx('sc__search__input-group', { 'sc__search__input-group--active': searchState })}>
        <i className={cx('zolaicon zolaicon-magnifying-glass sc__search__glass-icon', { 'sc__search__glass-icon--active': searchState })} />
        <input
          className={cx('sc__search__input', { 'sc__search__input--active': searchState })}
          type="search"
          value={searchToken}
          placeholder="Search Guests"
          onChange={handleOnChange}
        />
      </div>
      {searchState && (
        <button
          className="sc__search__close-button"
          onClick={handleOnClose}
        >
          <i className="zolaicon zolaicon-close" />
        </button>
      )}
    </div>
    {noGuests && searchState && (
      <div className="sc__no-search-results">
        <h3 className="sc__no-search-results__header">Hm… we couldn’t find a match.</h3>
        <p className="sc__no-search-results__text">Make sure you’ve entered the correct name, or click below to add a new guest.</p>
        <button onClick={onAddGuestGroup} className="sc__no-search-results__add-button">+ Add New Guest</button>
      </div>
    )}
  </React.Fragment>
);

Search.propTypes = {
  searchState: PropTypes.bool,
  searchToken: PropTypes.string,
  handleOnChange: PropTypes.func.isRequired,
  handleOnClose: PropTypes.func.isRequired,
  onAddGuestGroup: PropTypes.func,
  noGuests: PropTypes.bool
};

export default Search;



// WEBPACK FOOTER //
// ./src/components/manage/seatingchart/GuestList/Search/Search.jsx